import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProcessorComponent } from './processor/processor.component';

const routes: Routes = [
  {
    path: 'home',
    children: [
      { path: '', component: DashboardComponent }
    ]
  },{
    path: 'home/:link',
    children: [
      { path: '', component: DashboardComponent }
    ]
  },
  {
    path: 'homeProcessor',
    children: [
      { path: '', component: ProcessorComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
